module.exports = "<p>\r\n  mini-perfomance-snapshot works!\r\n</p>\r\n"